const colors = {
	red: '#DC2626',
	orange: '#F59E0B',
	green: '#16A34A',
	lightgray: 'lightgray',
};

export { colors };
